import { createReducer } from '@reduxjs/toolkit'

import { brandsSummaryTableColumnsConfig } from 'configuration/tables/brandTable'
import {
    DATES,
    COUNTRIES,
    REGIONS,
    BRANDS,
    FACT_TYPES,
    LABELS,
    METRIC_FILTERS,
} from 'const/filters'
import { FILTERS, FILTER_SETTINGS } from 'const/reducerKeys'
import { serializeColumns } from 'helpers/tables'
import { defaultPage, getDefaultTable } from 'reducers/ui/defaults'

const defaultState = {
    [FILTERS]: {
        [FACT_TYPES]: [],
        [REGIONS]: [],
        [COUNTRIES]: [],
        [BRANDS]: [],
        [LABELS]: [],
        [METRIC_FILTERS]: [],
    },
    [FILTER_SETTINGS]: {
        anchored: [DATES, FACT_TYPES],
        order: [METRIC_FILTERS, REGIONS, COUNTRIES, BRANDS, LABELS],
        displayState: {
            [METRIC_FILTERS]: true,
            [REGIONS]: true,
            [COUNTRIES]: true,
            [BRANDS]: true,
            [LABELS]: true,
        },
    },
    ...defaultPage,
    table: getDefaultTable(serializeColumns(brandsSummaryTableColumnsConfig), {
        showTotalRow: true,
    }),
}

export default createReducer(defaultState, () => {})
